import { Button, Dialog, Text, Toggle } from '@cinesend/ui-kit'
import { WIDGET_DESCRIPTIONS, WIDGET_IDS, WIDGET_LABELS } from './use_dashboard_layout'

const AddWidgetModal = ({ visibleIds, onToggle, onClose }) => {
  return (
    <Dialog
      open
      title='Manage widgets'
      onOpenChange={(open) => !open && onClose()}
      hasActions
      actionPrimary={
        <Button variant='primary' onClick={onClose}>
          Done
        </Button>
      }
    >
      <div className='flex flex-col gap-4 px-6 pb-6 pt-4'>
        <ul className='m-0 flex list-none flex-col divide-y divide-[color:var(--cs-color-border-subtle)] p-0'>
          {WIDGET_IDS.map((id) => {
            const visible = visibleIds.includes(id)
            const label = WIDGET_LABELS[id]
            return (
              <li key={id} className='flex items-start justify-between gap-6 py-4 first:pt-0 last:pb-0'>
                <div className='min-w-0 flex-1'>
                  <Text as='p' variant='sm-medium'>
                    {label}
                  </Text>
                  <Text as='p' variant='xs' tone='secondary' className='mt-1'>
                    {WIDGET_DESCRIPTIONS[id]}
                  </Text>
                </div>
                <Toggle label={label} pressed={visible} onToggle={() => onToggle(id, !visible)} className='mt-0.5' />
              </li>
            )
          })}
        </ul>
      </div>
    </Dialog>
  )
}

export default AddWidgetModal
